module.exports = __webpack_public_path__ + "static/media/logo.750d1b91.png";